export const PERMISSION_REGEXP = /do not have permission/;
